import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { deleteOffersServer, getOffersServer } from "../../../apis/offersApi";
import getOffersColumns from "../../../const/Columns/getOffersColumns";
import { Link } from "react-router-dom";

const Offers = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredoffs, setFilteredOffs] = useState([]);

  useEffect(() => {
    fetchOffers();
  }, []);

  useEffect(() => {
    if (offers?.length > 0) {
      const filtered = offers?.filter((off) =>
        off.title?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredOffs(filtered);
    }
  }, [searchText, offers]);

  const fetchOffers = async () => {
    try {
      const res = await getOffersServer();
      setOffers(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteOffers = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Offers?",
    );
    if (isConfirmed) {
      await deleteOffersServer(id);
      setLoading(true);
      fetchOffers();
    }
  };

  const columns = getOffersColumns(deleteOffers);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/addOffers" className="btn add-new btn-primary mb-3">
                Add Offers
              </Link>
              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by title"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredoffs?.length > 0
                      ? filteredoffs
                      : offers?.length > 0
                        ? offers
                        : []
                  }
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Offers;
